import { QueryHookOptions, useQuery } from '@apollo/client';

import query from './createDepotAccountContactsQuery.graphql';

export type ContactOption =
  CreateDepotAccountContactsQuery['managedPlatformAccount']['globalContacts']['collection'][number];

export const useCreateDepotAccountContactsQuery = (
  variables: CreateDepotAccountContactsQueryVariables,
  options?: QueryHookOptions<
    CreateDepotAccountContactsQuery,
    CreateDepotAccountContactsQueryVariables
  >,
) =>
  useQuery<
    CreateDepotAccountContactsQuery,
    CreateDepotAccountContactsQueryVariables
  >(query, { variables, ...options });
